import { render, staticRenderFns } from "./queryList.vue?vue&type=template&id=800648be&scoped=true&"
import script from "./queryList.vue?vue&type=script&lang=js&"
export * from "./queryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800648be",
  null
  
)

export default component.exports